'use strict'
require('core-js/modules/es.array.every')
require('core-js/modules/es.array.for-each')
require('core-js/modules/es.array.includes')
require('core-js/modules/es.array.index-of')
require('core-js/modules/es.array.join')
require('core-js/modules/es.array.slice')
require('core-js/modules/es.array.sort')
require('core-js/modules/es.parse-int')
require('core-js/modules/es.regexp.exec')
require('core-js/modules/es.string.includes')
require('core-js/modules/es.string.replace')
require('core-js/modules/es.string.split')
require('core-js/modules/web.dom-collections.for-each')
exports.__esModule = true
exports.validateNumOrNumRangesStr = validateNumOrNumRangesStr
exports.validateNumsArr = validateNumsArr
exports.parseNumOrNumRangesStr = parseNumOrNumRangesStr
exports.numsToStrWithCollapsing = numsToStrWithCollapsing
exports.isAnyDefault = isAnyDefault

var _is = require('../is')

var _func = require('../func')

var oneDigitRegex = /\d/
var numRangeRegex = /^\d{1,2}-\d{1,2}$/

function logErrAndReturnDefault(str) {
  console.error('invalid number range ', str)
  return []
}
function expandNumRange(str) {
  if (!numRangeRegex.test(str)) return logErrAndReturnDefault(str)
  var period = str.split('-')
  var start = parseInt(period[0])
  var end = parseInt(period[1])
  if (start >= end) return logErrAndReturnDefault(str)
  var nums = []

  while (start <= end) {
    nums.push(start)
    start++
  }

  return nums
}

function validateNumOrNumRangesStr(str, firstChar) {
  return (
    (0, _is.isStr)(str) &&
    str.indexOf(firstChar) === 0 &&
    str
      .slice(1)
      .split(',')
      .every(function(numOrNumRange) {
        return oneDigitRegex.test(numOrNumRange) || numRangeRegex.test(numOrNumRange)
      })
  )
}

function validateNumsArr(nums, maxNum, minNum) {
  var min = (0, _is.isNum)(minNum) ? minNum : 0
  return (
    (0, _is.isArr)(nums) &&
    nums.every(function(num) {
      return num >= min && num <= maxNum
    })
  )
}

function parseNumOrNumRangesStr(str, firstChar) {
  var nums = []

  str
    .replace(firstChar, '')
    .split(',')
    .forEach(function(numOrNumRange) {
      // TODO: add Array.includes polyfill
      if (numOrNumRange.includes('-')) {
        nums.push.apply(nums, expandNumRange(numOrNumRange))
      } else {
        nums.push(parseInt(numOrNumRange))
      }
    })

  nums.sort(_func.sortCb_num)
  return nums
}

function numsToStrWithCollapsing(nums, firstChar) {
  nums.sort(_func.sortCb_num)
  var numsOrNumRanges = []
  var sublCount = 0
  nums.forEach(function(num, ind) {
    var nextNum = nums[ind + 1] || 0

    if (num + 1 === nextNum) {
      sublCount++
      return
    }

    switch (true) {
      case sublCount === 1:
        numsOrNumRanges.push('' + (num - 1), '' + num)
        break
      case sublCount > 1:
        numsOrNumRanges.push(num - sublCount + '-' + num)
        break
      default:
        numsOrNumRanges.push('' + num)
        break
    }

    sublCount = 0
  })

  return firstChar + numsOrNumRanges.join(',')
}

function isAnyDefault(arr, min, max) {
  if (arr.length === 0) return true
  for (var i = min; i <= max; i++) {
    if (!arr.includes(i)) return false
  }
  return true
}



//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/TimingParser/utils.js
// module id = 125
// module chunks = 0